import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VExpansionPanels,
    {
      staticClass: "rtls-expansion-panels attribute-filter-panel",
      attrs: { tile: "" },
      model: {
        value: _vm.isOpenState,
        callback: function ($$v) {
          _vm.isOpenState = $$v
        },
        expression: "isOpenState",
      },
    },
    [
      _c(
        VExpansionPanel,
        { staticClass: "rtls-expansion-panel mb-4", attrs: { focusable: "" } },
        [
          _c(
            VExpansionPanelHeader,
            {
              staticClass: "panel-header",
              scopedSlots: _vm._u([
                {
                  key: "actions",
                  fn: function () {
                    return [_vm._m(0)]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "div",
                { staticClass: "body-2" },
                [
                  _c("span", { staticClass: "filter-text-title" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$tkey("title")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "font-weight-bold filter-text" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$tkey("numberOfProducts")) +
                          "\n                    "
                      ),
                      !_vm.getProductsInProgress
                        ? [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.productsNumberInPromotion) +
                                "\n                    "
                            ),
                          ]
                        : [_c("spinner-dynamic", { staticClass: "pt-1" })],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.showOverwlowError
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "attribute-filter-panel__max-products-error",
                        },
                        [
                          _c("span", { staticClass: "error--text" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$tkey("maxProductsNumberError", {
                                    maxAllowedProductCount:
                                      _vm.maxAllowedProductCount,
                                  })
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            VExpansionPanelContent,
            { staticClass: "panel-header" },
            [
              _c(
                VCardText,
                { staticClass: "px-6 pt-3" },
                [
                  _vm._l(_vm.activeAttributesCount, function (attributeRow) {
                    return _c(
                      VFlex,
                      { key: _vm.attributeScope[attributeRow - 1].key },
                      [
                        _c("attribute-filter", {
                          key: `Filter::${
                            _vm.attributeScope[attributeRow - 1].key
                          }`,
                          attrs: {
                            "attribute-row-index": attributeRow - 1,
                            "attribute-scope":
                              _vm.stagingAreaPromotion.attributeScope,
                            "validate-attribute-select":
                              _vm.activeAttributesCount > 1,
                          },
                          on: {
                            "remove-attribute-row": _vm.onRemoveAttributeRow,
                            "products-number-updated":
                              _vm.debouncedOnProductsNumberUpdated,
                          },
                        }),
                        _vm._v(" "),
                        _c(VDivider, {
                          key: `Divider::${attributeRow}`,
                          staticClass: "my-2",
                        }),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "attribute-filter-panel__actions" },
                    [
                      _c(
                        VBtn,
                        {
                          attrs: {
                            disabled: _vm.addButtonDisabled,
                            right: "",
                            icon: "",
                            text: "",
                            depressed: "",
                          },
                          on: { click: _vm.addAttributeRow },
                        },
                        [_vm._m(2)],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "attribute-filter-panel__actions--confirmation",
                        },
                        [
                          _vm.isSavingInProgress
                            ? _c("spinner-dynamic", { staticClass: "pt-2" })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(VIcon, { attrs: { color: "indigo darken-2" } }, [
      _vm._v("\n                    expand_more\n                "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(VIcon, { staticClass: "filter-text" }, [
      _vm._v("\n                    filter_list\n                "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(VIcon, { attrs: { color: "indigo darken-2" } }, [
      _vm._v("add_box"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }